import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getOutdoorsCampaigns({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_OUTDOORS_CAMPAIGNS_REQUEST')

        return axios
            .get(`/outdoors/outdoor-campaigns${paginate}${query}`)
            .then(response => {
                commit('GET_OUTDOORS_CAMPAIGNS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_OUTDOORS_CAMPAIGNS_FAILURE')
                handleApiError(error, 'Pobranie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOutdoorsCampaign(context, id) {
        return axios
            .get(`/outdoors/outdoor-campaigns/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createOutdoorsCampaign(context, payload) {
        return axios
            .post('/outdoors/outdoor-campaigns', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateOutdoorsCampaign(context, payload) {
        return axios
            .put(`/outdoors/outdoor-campaigns/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteOutdoorsCampaign({ commit }, id) {
        return axios
            .delete(`/outdoors/outdoor-campaigns/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Kampania została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOutdoorsCampaignLocalizations({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_OUTDOORS_CAMPAIGN_LOCALIZATIONS_REQUEST')

        return axios
            .get(`/outdoors/outdoor-campaign-localizations${paginate}${query}`)
            .then(response => {
                commit('GET_OUTDOORS_CAMPAIGN_LOCALIZATIONS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_OUTDOORS_CAMPAIGN_LOCALIZATIONS_FAILURE')
                handleApiError(error, 'Pobranie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOutdoorsCampaignLocalization(context, id) {
        return axios
            .get(`/outdoors/outdoor-campaign-localizations/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateOutdoorsCampaignLocalization({ commit }, payload) {
        return axios
            .put(`/outdoors/outdoor-campaign-localizations/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Lokalizacja została zedytowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis lokalizacji nie powiódł się.')

                return Promise.reject(error)
            })
    },
    getOutdoorsCampaignLocalizationScreens({commit}, id) {
        return axios
            .get(`/outdoors/outdoor-campaign-localization-screens?campaignLocalization_id=${id}`)
            .then(response => {
                commit('GET_OUTDOORS_CAMPAIGN_LOCALIZATION_SCREENS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie ekranów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOutdoorsCampaignLocalizationScreen(context, id) {
        return axios
            .get(`/outdoors/outdoor-campaign-localization-screens/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateOutdoorsLocalizationScreen({ commit }, payload) {
        return axios
            .put(`/outdoors/outdoor-campaign-localization-screens/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Ekran został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis ekranu nie powiódł się.')

                return Promise.reject(error)
            })
    },
    addProductionFileAttachment({ commit, state }, { formData, abort}) {
        if (!abort) {
            const cancelToken = axios.CancelToken
            const cancelTokenSource = cancelToken.source()

            commit('SET_CANCEL_TOKEN', cancelTokenSource)
        } else {
            state.cancelToken.cancel('Canceled')
        }

        commit('FILE_PROGRESS', {
            show: true,
            value: 0
        }, { root: true })

        return axios
            .post('/outdoors/campaign-product/file/upload', formData, {
                cancelToken: state.cancelToken.token,
                timeout: 900000, // 15 min
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    commit('FILE_PROGRESS', {
                        show: false,
                        value: percentCompleted
                    }, { root: true })
                }
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie pliku produkcyjnego nie powiodło się.')

                return Promise.reject(error)
            })
            .finally(() => {
                commit('SET_CANCEL_TOKEN', null)
                commit('FILE_PROGRESS', {
                    show: false,
                    value: 0
                }, { root: true })
            })
    },
    deleteProductionFileAttachment(context, id) {
        return axios
            .delete(`/outdoors/campaign-product/file/upload/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie pliku produkcyjnego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductTemplate(context, payload = {
        productTemplateId: '',
        query: ''}) {
        const query = payload.query

        return axios
            .get(`/product-templates/product-templates/${payload.productTemplateId}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do szablonu produktowego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateReport({ commit }, payload) {
        return axios
            .post('/outdoors/outdoor-export-campaign', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${payload.userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setOutdoorsCampaignFilters({ commit }, filters) {
        commit('SET_OUTDOORS_CAMPAIGN_FILTERS', filters)
    },
    updateCampaignCreateProductList({ commit }, { product, productTemplate}) {
        commit('UPDATE_CAMPAIGN_CREATE_PRODUCT_LIST', { product, productTemplate })
    },
    updateCampaignCreateProductTemplate({ commit }, { index, product, productTemplate }) {
        commit('UPDATE_CAMPAIGN_CREATE_PRODUCT_TEMPLATE', { index, product, productTemplate })
    },
    removeCampaignCreateProductTemplate({ commit }, index) {
        commit('REMOVE_CAMPAIGN_CREATE_PRODUCT_TEMPLATE', index)
    },
    temporarySaveCampaignData({ commit }, data ) {
        commit('TEMPORARY_SAVE_CAMPAIGN_DATA', data)
    },
    clearCampaignCreate({ commit }) {
        commit('CLEAR_CAMPAIGN_CREATE')
    },
    setIsCampaignCreated({ commit }) {
        commit('SET_IS_CAMPAIGN_CREATED')
    },
    clearIsCampaignCreated({ commit }) {
        commit('CLEAR_IS_CAMPAIGN_CREATED')
    }
}